module.exports = __webpack_public_path__ + "static/media/m44.2d755fdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m44.jpg
// module id = 252
// module chunks = 0